import { IWPImage, IWPLink } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

export type IFooterData = {
  wp: {
    siteSettings: {
      siteSettings: {
        footer: {
          link: IWPLink;
          logo: IWPImage;
        };
      };
    };
  };
};

const useFooterData = (lang: Languages) => {
  const { wp }: IFooterData = useStaticQuery(
    graphql`
      {
        wp {
          siteSettingsSV {
            acf_settings {
              labels {
                signUpLabel
                cookieHeaderLabel
                cookieTextLabel
                acceptLabel
                declineLabel
              }
              footer {
                columns {
                  title
                  links {
                    boxicon
                    link {
                      title
                      url
                    }
                  }
                }
                certificates {
                  text
                  image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                      }
                    }
                    altText
                  }
                  link {
                    title
                    url
                  }
                }
              }
            }
          }
          siteSettingsEN {
            acf_settings {
              labels {
                signUpLabel
                cookieHeaderLabel
                cookieTextLabel
                acceptLabel
                declineLabel
              }
              footer {
                columns {
                  title
                  links {
                    boxicon
                    link {
                      title
                      url
                    }
                  }
                }
                certificates {
                  text
                  image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          formats: AUTO
                          layout: FULL_WIDTH
                          placeholder: BLURRED
                        )
                      }
                    }
                    altText
                  }
                  link {
                    title
                    url
                  }
                }
              }
            }
          }
          siteSettingsZH {
            acf_settings {
              labels {
                signUpLabel
                cookieHeaderLabel
                cookieTextLabel
                acceptLabel
                declineLabel
              }
              footer {
                columns {
                  title
                  links {
                    boxicon
                    link {
                      title
                      url
                    }
                  }
                }
                certificates {
                  text
                  image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          formats: AUTO
                          layout: FULL_WIDTH
                          placeholder: BLURRED
                        )
                      }
                    }
                    altText
                  }
                  link {
                    title
                    url
                  }
                }
              }
            }
          }
        }
      }
    `
  );
  return wp[`siteSettings${lang.toUpperCase()}`].acf_settings;
};
export default useFooterData;
